export default __webpack_public_path__ + "static/oberon-travelbase-ds-5-b2e8ec38e5aa115ace44ed0f9ad7342e.jpg";